"use strict";

exports.__esModule = true;

var _promise = require("babel-runtime/core-js/promise");

var _promise2 = _interopRequireDefault(_promise);

var _assign = require("babel-runtime/core-js/object/assign");

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

var _exifJs = require("exif-js");

var _utils = require("./utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var mimeTypes = {
  PNG: "image/png",
  JPEG: "image/jpeg",
  WEBP: "image/webp",
  BMP: "image/bmp"
};

var maxSteps = 4;
var scaleFactor = Math.log(2);
var supportMimeTypes = (0, _keys2["default"])(mimeTypes).map(function (type) {
  return mimeTypes[type];
});
var defaultType = mimeTypes.JPEG;

function isSupportedType(type) {
  return supportMimeTypes.includes(type);
}

var Compress = function () {
  function Compress(file, option) {
    (0, _classCallCheck3["default"])(this, Compress);

    this.config = (0, _assign2["default"])({
      quality: 0.92,
      noCompressIfLarger: false
    }, option);
    this.file = file;
  }

  Compress.prototype.process = function process() {
    var _this = this;

    this.outputType = this.file.type;
    var srcDimension = {};
    if (!isSupportedType(this.file.type)) {
      return _promise2["default"].reject(new Error("unsupported file type: " + this.file.type));
    }

    return this.getOriginImage().then(function (img) {
      return _this.getCanvas(img);
    }).then(function (canvas) {
      // 计算图片缩小比例，取最小值，如果大于1则保持图片原尺寸
      var scale = 1;
      if (_this.config.maxWidth) {
        scale = Math.min(1, _this.config.maxWidth / canvas.width);
      }
      if (_this.config.maxHeight) {
        scale = Math.min(1, scale, _this.config.maxHeight / canvas.height);
      }
      srcDimension.width = canvas.width;
      srcDimension.height = canvas.height;
      return _this.doScale(canvas, scale);
    }).then(function (result) {
      var distBlob = _this.toBlob(result);
      if (distBlob.size > _this.file.size && _this.config.noCompressIfLarger) {
        return {
          dist: _this.file,
          width: srcDimension.width,
          height: srcDimension.height
        };
      }
      return {
        dist: distBlob,
        width: result.width,
        height: result.height
      };
    });
  };

  Compress.prototype.clear = function clear(ctx, width, height) {
    // jpeg 没有 alpha 通道，透明区间会被填充成黑色，这里把透明区间填充为白色
    if (this.outputType === defaultType) {
      ctx.fillStyle = "#fff";
      ctx.fillRect(0, 0, width, height);
    } else {
      ctx.clearRect(0, 0, width, height);
    }
  };
  // 通过 file 初始化 image 对象


  Compress.prototype.getOriginImage = function getOriginImage() {
    var _this2 = this;

    return new _promise2["default"](function (resolve, reject) {
      var url = (0, _utils.createObjectURL)(_this2.file);
      var img = new Image();
      img.onload = function () {
        resolve(img);
      };
      img.onerror = function () {
        reject("image load error");
      };
      img.src = url;
    });
  };

  Compress.prototype.getCanvas = function getCanvas(img) {
    var _this3 = this;

    return new _promise2["default"](function (resolve, reject) {
      // 通过得到图片的信息来调整显示方向以正确显示图片，主要解决 ios 系统上的图片会有旋转的问题
      _exifJs.EXIF.getData(img, function () {
        var orientation = _exifJs.EXIF.getTag(img, "Orientation") || 1;

        var _getTransform = (0, _utils.getTransform)(img, orientation),
            width = _getTransform.width,
            height = _getTransform.height,
            matrix = _getTransform.matrix;

        var canvas = document.createElement("canvas");
        var context = canvas.getContext("2d");
        canvas.width = width;
        canvas.height = height;
        _this3.clear(context, width, height);
        context.transform.apply(context, matrix);
        context.drawImage(img, 0, 0);
        resolve(canvas);
      });
    });
  };

  Compress.prototype.doScale = function doScale(source, scale) {
    if (scale === 1) {
      return _promise2["default"].resolve(source);
    }
    // 不要一次性画图，通过设定的 step 次数，渐进式的画图，这样可以增加图片的清晰度，防止一次性画图导致的像素丢失严重
    var sctx = source.getContext("2d");
    var steps = Math.min(maxSteps, Math.ceil(1 / scale / scaleFactor));

    var factor = Math.pow(scale, 1 / steps);

    var mirror = document.createElement("canvas");
    var mctx = mirror.getContext("2d");

    var width = source.width,
        height = source.height;

    var originWidth = width;
    var originHeight = height;
    mirror.width = width;
    mirror.height = height;
    var src = void 0,
        context = void 0;

    for (var i = 0; i < steps; i++) {

      var dw = width * factor | 0;
      var dh = height * factor | 0;
      // 到最后一步的时候 dw, dh 用 目标缩放尺寸，否则会出现最后尺寸偏小的情况
      if (i === steps - 1) {
        dw = originWidth * scale;
        dh = originHeight * scale;
      }

      if (i % 2 === 0) {
        src = source;
        context = mctx;
      } else {
        src = mirror;
        context = sctx;
      }
      // 每次画前都清空，避免图像重叠
      this.clear(context, width, height);
      context.drawImage(src, 0, 0, width, height, 0, 0, dw, dh);
      width = dw;
      height = dh;
    }

    var canvas = src === source ? mirror : source;
    // save data
    var data = context.getImageData(0, 0, width, height);

    // resize
    canvas.width = width;
    canvas.height = height;

    // store image data
    context.putImageData(data, 0, 0);

    return _promise2["default"].resolve(canvas);
  };

  // 这里把 base64 字符串转为 blob 对象


  Compress.prototype.toBlob = function toBlob(result) {
    var dataURL = result.toDataURL(this.outputType, this.config.quality);
    var buffer = atob(dataURL.split(",")[1]).split("").map(function (char) {
      return char.charCodeAt(0);
    });
    var blob = new Blob([new Uint8Array(buffer)], { type: this.outputType });
    return blob;
  };

  return Compress;
}();

var compressImage = function compressImage(file, options) {
  return new Compress(file, options).process();
};

exports["default"] = compressImage;


//////////////////
// WEBPACK FOOTER
// ./src/compress.js
// module id = 110
// module chunks = 0